import { api } from '../apiClient';

export const chatService = {
  // Get all chat rooms for the user
  getChatRooms: async (): Promise<{ success: boolean; chat_rooms: any[] }> => {
    const response = await api.get('/chat/rooms/');
    return response.data;
  },

  // Get messages for a specific chat room
  getChatMessages: async (roomId: number, page: number = 1, pageSize: number = 50): Promise<{ success: boolean; messages: any[]; has_more: boolean }> => {
    const response = await api.get(`/chat/rooms/${roomId}/messages/`, {
      params: { page, page_size: pageSize }
    });
    return response.data;
  },

  // Send a message to a chat room
  sendMessage: async (roomId: number, messageData: {
    message_type: 'text' | 'image' | 'file';
    content?: string;
    file?: File;
  }): Promise<{ success: boolean; message: any }> => {
    const formData = new FormData();
    formData.append('message_type', messageData.message_type);
    
    if (messageData.content) {
      formData.append('content', messageData.content);
    }
    
    if (messageData.file) {
      formData.append('file', messageData.file);
    }

    const response = await api.post(`/chat/rooms/${roomId}/send/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Start a chat for an event
  startEventChat: async (eventId: number, type: 'private' | 'public' = 'private'): Promise<{ success: boolean; chat_room: any }> => {
    const response = await api.post('/chat/event/start/', {
      event_id: eventId,
      type: type
    });
    return response.data;
  },

  // Get beacon data for chat widget
  getBeaconData: async (): Promise<{ success: boolean; recent_events: any[]; recent_chats: any[] }> => {
    const response = await api.get('/chat/beacon/data/');
    return response.data;
  },

  // Mark messages as read
  markMessagesRead: async (roomId: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.post(`/chat/rooms/${roomId}/read/`);
    return response.data;
  },

  // Get chat participants
  getChatParticipants: async (roomId: number): Promise<{ success: boolean; participants: any[] }> => {
    const response = await api.get(`/chat/rooms/${roomId}/participants/`);
    return response.data;
  },
};

